var map = {
	"./ar.json": [
		"./translation/ar.json",
		"ar-json"
	],
	"./bn.json": [
		"./translation/bn.json",
		"bn-json"
	],
	"./de.json": [
		"./translation/de.json",
		"de-json"
	],
	"./es.json": [
		"./translation/es.json",
		"es-json"
	],
	"./fr.json": [
		"./translation/fr.json",
		"fr-json"
	],
	"./id.json": [
		"./translation/id.json",
		"id-json"
	],
	"./it.json": [
		"./translation/it.json",
		"it-json"
	],
	"./ko.json": [
		"./translation/ko.json",
		"ko-json"
	],
	"./messages.json": [
		"./translation/messages.json",
		"messages-json"
	],
	"./nl.json": [
		"./translation/nl.json",
		"nl-json"
	],
	"./pl.json": [
		"./translation/pl.json",
		"pl-json"
	],
	"./pt.json": [
		"./translation/pt.json",
		"pt-json"
	],
	"./ru.json": [
		"./translation/ru.json",
		"ru-json"
	],
	"./si.json": [
		"./translation/si.json",
		"si-json"
	],
	"./sw.json": [
		"./translation/sw.json",
		"sw-json"
	],
	"./th.json": [
		"./translation/th.json",
		"th-json"
	],
	"./tr.json": [
		"./translation/tr.json",
		"tr-json"
	],
	"./vi.json": [
		"./translation/vi.json",
		"vi-json"
	],
	"./zh.json": [
		"./translation/zh.json",
		"zh-json"
	],
	"./zh_cn.json": [
		"./translation/zh_cn.json",
		"zh_cn-json"
	],
	"./zh_tw.json": [
		"./translation/zh_tw.json",
		"zh_tw-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./translation lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;